import * as addressesEndpointsGenerators from './endpointsGenerators/wcm/addresses/addressesEndpointsGenerators';
import * as servicesEndpointsGenerators from './endpointsGenerators/ecommerce/services/servicesEndpointsGenerators';
import * as translationsEndpointsGenerators from './endpointsGenerators/wcm/translations/translationsEndpointsGenerators';
import * as wcmImagesEndpointsGenerators from './endpointsGenerators/wcm/images/imagesEndpointsGenerators';
import * as topicsEndpointsGenerators from './endpointsGenerators/wcm/topics/topicsEndpointsGenerators';
import * as shortcutsEndpointsGenerators from './endpointsGenerators/wcm/shortcuts/shortcutsEndpointsGenerators';
import * as tcFBBEndpointsGenerators from './endpointsGenerators/wcm/tcFBB/tcFBBEndpointsGenerator';
import * as getOrderStatusGenerators from './endpointsGenerators/microApi/orderTrackingStatus/getOrderStatus';
import * as getSubscriberProductsGenerators from './endpointsGenerators/microApi/subscriberProducts/getSubscriberProducts';
import * as simManagement from './endpointsGenerators/microApi/simManagement/simManagement';
import * as getLoyaltyGroupsGenerators from './endpointsGenerators/microApi/loyaltyGroup/getLoyaltyGroups';
import * as getLoyaltyGroupDetailsGenerators from './endpointsGenerators/microApi/loyaltyGroup/getLoyaltyGroupDetails';
import * as getGroupSubscriptionsGenerators from './endpointsGenerators/microApi/loyaltyGroup/getGroupSubscriptions';
import * as getSubscriptionDetailsGenerators from './endpointsGenerators/microApi/loyaltyGroup/getSubscriptionDetails';
import * as updateLoyaltyGroupGenerators from './endpointsGenerators/microApi/loyaltyGroup/updateLoyaltyGroup';
import * as deleteLoyaltyGroupGenerators from './endpointsGenerators/microApi/loyaltyGroup/deleteLoyaltyGroup';
import * as unsubscribeSubscriptionGenerators from './endpointsGenerators/microApi/loyaltyGroup/unsubscribeSubscription';
import * as bankItemsEndpointsGenerators from './endpointsGenerators/wcm/bankItems/bankItemsEndpointsGenerators';
import * as getProductsByParentCategoryGenerator from './endpointsGenerators/eshopApi/products/getProductsByParentCategory';
import * as getInventoryByProductIdGenerator from './endpointsGenerators/eshopApi/inventory/getInventoryByProductId';
import * as getProductByIdGenerator from './endpointsGenerators/eshopApi/product/getProductById';
import * as getCatEntryGenerator from './endpointsGenerators/eshopApi/product/getCatEntry';

import * as cartGenerator from './endpointsGenerators/eshopApi/cart/cart';
import * as addIdentityGenerator from './endpointsGenerators/eshopApi/identity/getIdentity';
import * as getPurchaseDeviceHistoryGenerator from './endpointsGenerators/eshopApi/purchaseDeviceHistory/getPurchaseDeviceHistory';
import * as getPurchaseDeviceOrderGenerator from './endpointsGenerators/eshopApi/purchaseDeviceHistory/getPurchaseDeviceOrder';
import * as getOrderTrackingGenerator from './endpointsGenerators/eshopApi/purchaseDeviceHistory/getOrderTracking';
import * as isRiyadaCustomerGenerator from './endpointsGenerators/omantelMicroApi/microbundle/riyadaCustomer';
import * as validateUserName from './endpointsGenerators/omantelMicroApi/validateUserName/validateUserName';
import * as getBtlPlans from './endpointsGenerators/omantelMicroApi/getBtlPlans/getBtlPlans';
import * as readNotification from './endpointsGenerators/omantelMicroApi/readNotification/readNotification';
import * as getPaymentRequestStatus from './endpointsGenerators/payment/paymentRequestStatus/paymentRequestStatus';
import * as createFbbOrder from './endpointsGenerators/omantelMicroApi/createFbbOrder/createFbbOrder';
import { BillingType } from 'utils/api/models/accounts/singleAccount';
import { env } from 'config/app.config';
import { fetchTranslations } from './endpointsGenerators/wcm/translations/translationsEndpointsGenerators';
import { getBOMIntro } from './endpointsGenerators/wcm/BOM/introEndpointsGenerators.ts';
import { fetchPaymentHistory } from './endpointsGenerators/payment/fetchPaymentHistory';
import { userGuides } from './endpointsGenerators/wcm/userGuide/userGuideEndpointsGenerators';
import { deletePaymentToken } from './endpointsGenerators/payment/deletePaymentToken';
import store from 'redux/store';

export const endpoints: types.endpoints.list = {
	omantelApi: {
		requestResetPasswordOtp: {
			url: 'Registration/Action!generateLoginAccessTokenRestPost',
			method: 'POST',
		},
		sendRegisterBusinessAccount: {
			url: 'CorpoManagement/Action!sendRegisterBusinessAccountRestPost',
		},
		createHbbAccount: {
			url: 'AccountManagement/Action!createFbbAccountRestPost',
		},
		validateAdslLogin: {
			url: 'AccountManagement/Action!validateAdslLoginRestPost',
		},
		// ProductInventory
		getProducts: {
			url: 'ProductInventory/Action!getProductsOperationRestPost',
		},
		getDepartmentsForCurrentUser: {
			url: 'CorpoMasterChild/Action!getDepartmentsForCurrentUserRestPost',
		},
		getCorpAccountsForCurrentUser: {
			url: 'CorpoMasterChild/Action!getCorpAccountsForCurrentUserRest',
			method: 'GET',
		},
		getCorpAccountsWithAdminsForCurrentUser: {
			url: 'CorpoMasterChild/Action!getCorpAccountsForCurrentUserRestPost',
			method: 'POST',
		},
		deleteAllAccountsForArborIdOperation: {
			url: 'UserManagement/Action!DeleteAllAccountsForArborIdOperationRestPost',
		},
		deleteAllAccountsForArborIdInitialize: {
			url: 'UserManagement/Action!DeleteAllAccountsForArborIdInitializeRestPost',
		},
		// UsageSummary
		getUsage: {
			url: 'UsageSummary/Action!getUsageRestPost',
		},
		// Settings
		createProductOrder: {
			url: 'ProductOrdering/Action!createProductOrderOperationRestPost',
		},
		createProductOrderWithOTP: {
			url: 'ProductOrdering/Action!validateAndCreateProductOrderOperationRestPost',
		},
		getCorpUsersForNumber: {
			url: 'CorpoMasterChild/Action!getCorpUsersForNumberRestPost',
			method: 'POST',
		},
		assignNumbersForCorpUserRestPost: {
			url: 'CorpoMasterChild/Action!assignNumersForCorpUserRestPost',
			method: 'POST',
		},
		// PaymentManagement
		getCustomerAccountBills: {
			url: 'PaymentManagement/Action!getCustomerUnpaidBillsForAccountsRest',
		},
		getCustomerBills: {
			url: 'PaymentManagement/Action!getCustomerBillsOperationRestPost',
		},
		makePayment: {
			url: 'CybersourcePayments/Action!MakePaymentOperationRestPost',
		},
		makeBOMPayment: {
			url: 'payment-processing-service/v1/bm/payment',
			method: 'POST',
		},
		deletePaymentToken: deletePaymentToken,
		getPaymentSummary: {
			url: 'payment-processing-service/v1/summary',
			method: 'POST',
		},
		getAccountNumberInfo: {
			url: 'Accounts/Action!GetAccountNumberInfoByNumberRestPost',
		},
		paymentSite: {
			url: 'CybersourcePayments/Action!GeneratePayerAuthenticationPostFormOperationRest',
		},
		// UserManagement
		getCurrentUserDetailsRest: {
			url: 'CorpoMasterChild/Action!getCurrentUserDetailsRest',
			method: 'GET',
		},
		getNumberUsage: {
			url: 'Usage/Action!getUsageOperationRestPost',
		},
		getCorpUserNumbersWithChilds: {
			method: 'GET',
			url: 'CorpoMasterChild/Action!getCorpUserNumbersWithChildsRest',
		},
		getCustomerAccountOperation: {
			url: 'CustomerManagment/Action!getCustomerAccountOperationRestPost',
		},
		updateAccountNameForLoggedUser: {
			url: 'Accounts/Action!updateAccountNameForLoggedUserRestPost',
		},
		getCustomerProducts: {
			url: 'ProductConfiguration/Action!getCustomerProductsRestPost',
		},
		initializeResetPassword: {
			url: 'PasswordReset/Action!InitializeResetPasswordOperationRestPost',
		},
		validateResetPasswordEmail: {
			url: 'PasswordReset/Action!ValidateResetPasswordEmailOperationRestPost',
		},
		resetPassword: {
			url: 'PasswordReset/Action!validateAndResetPasswordOperationRestPost',
		},
		getCorpUserDepartmentDataForNumber: {
			url: 'CorpoMasterChild/Action!getCorpUserDepartmentDataForNumberRestPost',
		},
		addDepartment: {
			url: 'CorpoMasterChild/Action!addDepartmentRestPost',
		},
		getDepartmentDetails: {
			url: 'CorpoMasterChild/Action!getDepartmentDetailsRestPost',
		},
		getCorpAccountDetails: {
			method: 'POST',
			url: 'CorpoMasterChild/Action!getCorpAccountDetailsRestPost',
		},
		updateDepartment: {
			url: 'CorpoMasterChild/Action!updateDepartmentRestPost',
		},
		deleteDepartment: {
			url: 'CorpoMasterChild/Action!deleteDepartmentRestPost',
		},
		getCorpAccountPhoto: {
			url: 'CorpoMasterChild/Action!getCorpAccountPhotoRestPost',
		},
		setCorpAccountPhoto: {
			url: 'CorpoMasterChild/Action!setCorpAccountPhotoRestPost',
		},
		getNumbersForAccount: {
			url: 'CorpoMasterChild/Action!getNumbersForAccountRestPost',
		},
		getNumbersForBillingAccount: {
			url: 'CorpoMasterChild/Action!getNumbersForBillingAccountRestPost',
		},
		assignNumbersToDepartment: {
			url: 'CorpoMasterChild/Action!assignNumbersToDepartmentRestPost',
		},
		getCorpAccountAdmins: {
			url: 'CorpoMasterChild/Action!getCorpAccountAdminsRestPost',
		},
		detachNumberFromProfile: {
			url: 'CorpoMasterChild/Action!detachNumberFromProfileRestPost',
		},
		getCorpAccountManagers: {
			url: 'CorpoMasterChild/Action!getCorpAccountManagersRestPost',
		},
		updateCorpAccountContact: {
			url: 'CorpoMasterChild/Action!updateCorpAccountContactRestPost',
		},
		getManagersForAccounts: {
			url: 'CorpoMasterChild/Action!getManagersForAccountsRestPost',
		},
		assignManagersToDepartment: {
			url: 'CorpoMasterChild/Action!assignManagersToDepartmentRestPost',
		},
		deleteManagersFromDepartment: {
			url: 'CorpoMasterChild/Action!deleteManagersFromDepartmentRestPost',
		},
		getCorpBillingIds: {
			url: 'CorpoMasterChild/Action!getCorpBillingIdsRest',
			method: 'GET',
		},
		getResources: {
			url: 'ResourceInventory/Action!getResourcesOperationRestPost',
		},
		addCorpUserPermissions: {
			url: 'CorpoMasterChild/Action!addCorpUserPermissionsRestPost',
		},
		createCorpUser: {
			url: 'CorpoMasterChild/Action!createCorpUserRestPost',
		},
		getCorpUserDetails: {
			url: 'CorpoMasterChild/Action!getCorpUserDetailsRestPost',
		},
		getCorpUsersForAccounts: {
			url: 'CorpoMasterChild/Action!getCorpUsersForAccountsRest',
		},
		updateCorpUserInformation: {
			url: 'CorpoMasterChild/Action!updateCorpUserInformationRestPost',
		},
		updateCorpAddress: {
			url: 'CorpoMasterChild/Action!updateCorpAddressRestPost',
		},
		updateCorpUserType: {
			url: 'CorpoMasterChild/Action!updateCorpUserTypeRestPost',
		},
		updateCorpUserPermissions: {
			url: 'CorpoMasterChild/Action!updateCorpUserPermissionsRestPost',
		},
		deleteCorpUsers: {
			url: 'CorpoMasterChild/Action!deleteCorpUsersRestPost',
		},
		getPaymentsHistoryForAccounts: {
			url: 'PaymentManagement/Action!getPaymentsHistoryForAccountsRestPost',
		},
		getPaymentHistoryRowItems: {
			url: 'PaymentManagement/Action!getPaymentHistoryRowItemsRestPost',
		},
		deleteAccountPermissionsForCorpUsers: {
			url: 'CorpoMasterChild/Action!deleteAccountPermissionsForCorpUsersRestPost',
		},
		getNumbersForUser: {
			url: 'CorpoMasterChild/Action!getNumbersForUserRestPost',
		},
		getBillsHistoryForAccounts: {
			url: 'PaymentManagement/Action!getBillsHistoryForAccountsRestPost',
		},
		getBillingAccountInformation: {
			url: 'CorpoMasterChild/Action!getBillingAccountInformationRestPost',
		},
		updateBillingAccountInformation: {
			url: 'CorpoMasterChild/Action!updateBillingAccountInformationRestPost',
		},
		getStatisticsForAccounts: {
			url: 'CorpoMasterChild/Action!getStatisticsForAccountsRest',
			method: 'GET',
		},
		importUsersFromFile: {
			url: 'CorpoMasterChild/Action!importUsersFromFileRestPost',
		},
		deleteNumbersAndUsersFromDepartment: {
			url: 'CorpoMasterChild/Action!deleteNumbersAndUsersFromDepartmentRestPost',
		},
		getPaymentReceipt: {
			url: 'PaymentManagement/Action!getPaymentReceiptRestPost',
		},
		updateEbillEmails: {
			url: 'UserManagement/Action!updateEbillEmailsRestPost',
		},
		resendActivationEmailRestPost: {
			url: 'CorpoMasterChild/Action!resendActivationEmailRestPost',
		},
		addAllAccountsForArborIdInitialize: {
			url: 'UserManagement/Action!AddAllAccountsForArborIdInitializeRestPost',
		},
		addAllAccountsForArborIdOperation: {
			url: 'UserManagement/Action!AddAllAccountsForArborIdOperationRestPost',
		},
		searchNumbersAndUsersRestPost: {
			url: 'CorpoMasterChild/Action!searchNumbersAndUsersRestPost',
		},
		detachNumbersFromUser: {
			url: 'CorpoMasterChild/Action!detachNumbersFromUserRestPost',
		},
		contactUsSelfcare: {
			url: 'FeedbackModel/Action!ContactUsSelfcareOperationRestPost',
		},
		directContactOperation: {
			url: 'FeedbackModel/Action!DirectContactOperationRestPost',
		},
		retrieveOsmIncident: {
			url: 'OsmIncident/Action!retrieveOsmIncidentRestPost',
		},
		retrieveOsmInteraction: {
			url: 'OsmInteraction/Action!retrieveOsmInteractionRestPost',
		},
		getCustomerUnpaidBillsForAccounts: {
			url: 'PaymentManagement/Action!getCustomerUnpaidBillsForAccountsRestPost',
		},
		getCpnAccount: {
			url: 'ResourceManagement/Action!getCpnAccountRestPost',
		},
		getBillAccountNoForNumber: {
			url: 'CorpoMasterChild/Action!getBillAccountNoForNumberRestPost',
		},
		submitProductOrderOperation: {
			url: 'ProductConfiguration/Action!submitProductOrderOperationRestPost',
		},
		getOrderStatus: {
			url: 'ResourceManagement/Action!getOrderStatusRestPost',
		},
		getPaymentTokensForCurrentUser: {
			url: 'CybersourcePayments/Action!GetPaymentTokensForCurrentUserOperationRestPost',
		},
		removePaymentToken: {
			url: 'CybersourcePayments/Action!RemovePaymentTokenByIfForCurrentUserRestPost',
		},
		sendResetAdslPasswordOtp: {
			url: 'Adsl/Action!sendResetAdslPasswordOtpRestPost',
		},
		confirmAdslResetPasswordOtp: {
			url: 'Adsl/Action!confirmAdslResetPasswordOtpRestPost',
		},
		getAccountManagerDetails: {
			url: 'DbService/Action!getAccountManagerDetailsRestPost',
		},
		updateOrganizationTaxId: {
			url: 'CorpoMasterChild/Action!updateOrganizationTaxIdRestPost',
		},
		checkResourceAvailable: {
			url: 'ResourceManagement/Action!checkResourceAvailableRestPost',
		},
		getSimDetails: {
			url: 'ResourceManagement/Action!getSimDetailsRestPost',
		},
		changePassword: {
			url: 'UserManagement/Action!ValidateAndChangePasswordOperationRestPost',
		},
		getCommitmentDetails: {
			url: 'PaymentManagement/Action!getCommitmentDetailsRestPost',
		},
		requestForOtp: {
			url: 'Services/Action!validateOperationRestPost',
		},
		deleteCorpUserPermissions: {
			url: 'CorpoMasterChild/Action!deleteCorpUserPermissionsRestPost',
		},
		getOrders: {
			url: 'OrderManagement/Action!getOrdersRestPost',
		},
		getPaymentsRequestStatus: getPaymentRequestStatus,
		getRefreshPayment: {
			url: 'payment-history-service/v1/bank-muscat/refresh-payment',
			method: 'POST',
		},
		fetchPaymentHistory: fetchPaymentHistory,
	},
	eCommerce: {
		services: servicesEndpointsGenerators,
	},
	mocky: {
		test: {
			method: 'GET',
			url: '5d039d7f3200006900d7479f',
		},
	},
	omantelPortal: {
		//Authentication
		login: {
			method: 'POST',
			url: 'auth/secureauth',
		},
		ltpaidentity: {
			method: 'POST',
			url: 'auth/ltpaidentity',
		},
		logout: {
			method: 'POST',
			url: 'auth/logout',
		},
	},
	wcm: {
		addresses: addressesEndpointsGenerators,
		images: wcmImagesEndpointsGenerators,
		translations: translationsEndpointsGenerators,
		topupValues: {
			url:
				'myconnect/technical_en/functionalnames?source=library&srv=cmpnt&cmpntid=8cfa1c1e-a748-430b-b041-b91266edc9e2&subtype=json',
		},
		charities: {
			url:
				'myconnect/technical_en/functionalnames?srv=cmpnt&subtype=json&cmpntid=db48b56a-4ef0-4aab-9fa8-c5f2be3390fa&source=library&lib=technical_en',
		},
		usageLogos: () => {
			const cmpnt =
				env === 'PROD' ? '28fe55ad-f2e0-4d96-9e4e-943f9b7ea832' : '32c62c3e-e718-47d7-9006-1790b3f56bb0';
			return {
				url: `myconnect/technical_en/functionalnames?srv=cmpnt&subtype=json&cmpntid=${cmpnt}&source=library&lib=technical_en`,
			};
		},
		internationalMinutesCountries: {
			url: 'myconnect/ebu_en/content?srv=cmpnt&cmpntname=tooltip_InternationalMinutes_COUNTRIES&source=library',
		},
		internationalMinutesDialingCodes: {
			url:
				'myconnect/ebu_en/content?srv=cmpnt&cmpntname=tooltip_InternationalMinutes_DIALING_CODES&source=library',
		},
		topics: topicsEndpointsGenerators,
		shortcuts: shortcutsEndpointsGenerators,
		bannedNumbers: {
			url: 'connect/ebu_en/content?srv=cmpnt&cmpntname=cpn_banned_numbers&source=library&subtype=json',
		},
		tcFBB: tcFBBEndpointsGenerators,
		errorMessages: {
			url: 'myconnect/ebu_en/labels?srv=cmpnt&cmpntname=Labels&source=library',
		},
		commitmentsWithBuiltInInternationalAndRoaming: {
			url:
				'myconnect/ebu_en/content?srv=cmpnt&cmpntname=commitments_with_built_in_international_roaming&source=library',
		},
		tariffPlansWithBuiltInInternationalAndRoaming: {
			url:
				'myconnect/ebu_en/content?srv=cmpnt&cmpntname=tariff_plans_with_built_in_international_roaming&source=library',
		},
		bankItems: bankItemsEndpointsGenerators,
		fetchTranslations: fetchTranslations,
		getBOMIntro: getBOMIntro,
		getUserGuidePDF: userGuides,
		alerts: {
			url: 'connect/technical_en/configurations/ebu_global_alerts',
		},
		getWhitelistedCRNumber: { url: 'connect/ebu_en/configurations/getDocumentsNumber' },
		getConfigurations: { url: 'connect/ebu_en/configurations/config' },
	},
	microApi: {
		orderTrackingStatus: getOrderStatusGenerators,
		loyaltyGroups: {
			createLoyaltyGroup: {
				url: 'loyalty-management/loyalty/group',
				method: 'POST',
			},
			getLoyaltyGroups: getLoyaltyGroupsGenerators,
			getLoyaltyGroupDetails: getLoyaltyGroupDetailsGenerators,
			updateLoyaltyGroup: updateLoyaltyGroupGenerators,
			deleteLoyaltyGroup: deleteLoyaltyGroupGenerators,
			getGroupSubscriptions: getGroupSubscriptionsGenerators,
			getSubscriptionDetails: getSubscriptionDetailsGenerators,
			unsubscribeSubscription: unsubscribeSubscriptionGenerators,
			addSubscription: {
				url: 'loyalty-management/subscription/loyalty',
				method: 'POST',
			},
			unsubscribeNumber: {
				url: 'loyalty-management/subscription/loyalty/number',
				method: 'DELETE',
			},
		},
		addonTopUps: {
			getSubscriptions: (upId: number | null) => {
				return {
					url: upId ? `loyalty-management/subscription?upId=${upId}` : 'loyalty-management/subscription',
				};
			},
		},
		billingPaymentTrack: {
			createOfflinePayment: {
				url: 'payment/payment/offline',
				method: 'POST',
			},
			getOfflinePayments: (upId: string | null) => {
				return {
					url: upId ? `payment/payment/offline?upId=${upId}` : 'payment/payment/offline',
				};
			},
			downloadAttachment: (attachmentId: number) => {
				return {
					url: `payment/payment/offline/attachments/${attachmentId}/content`,
				};
			},
		},
		osmInteraction: {
			createOsmInteraction: {
				url: 'ticketing/tickets/osminteraction',
				method: 'POST',
			},
			getTickets: (upId: number | null) => {
				return {
					url: upId ? `ticketing/tickets?upId=${upId}` : 'ticketing/tickets',
					method: 'GET',
				};
			},
		},
		interactions: {
			getInteractions: {
				url: 'customer-management/customer/interactions',
				method: 'POST',
			},
			getInteractionDetails: (interactionId: number) => {
				return {
					url: `customer-management/customer/interactions/${interactionId}`,
				};
			},
		},
		resourceInventory: simManagement,
		vouchers: {
			getSmartVoucher: ({ cr, phone }: { cr: string; phone: string }) => ({
				method: 'GET',
				url: `customer-management/customer/smart-voucher?crNumber=${cr}&phoneNumber=${phone}`,
			}),
			calculateInstallment: () => ({
				method: 'POST',
				url: `product-inventory/calculateInstallment`,
			}),
		},
		requests: {
			getUserRequests: () => ({
				method: 'POST',
				url: 'customer-management/requests/user-request/requests',
			}),
			updateUserRequest: () => ({
				method: 'PUT',
				url: 'customer-management/requests/user-request',
			}),
		},
		products: {
			getProductsDetails: (accountId: string, billingType: BillingType) => ({
				method: 'GET',
				url: `product-inventory/product-details?accountId=${accountId}&billingType=${billingType}`,
			}),
			changeTariffPlan: () => ({
				method: 'POST',
				url: 'product-inventory/changeTariffPlan',
			}),
		},
		services: simManagement,
		bills: {
			getBillingRequest: () => ({
				method: 'GET',
				url: 'customer-management/bills/billing-request',
			}),
			createBillingRequest: () => ({
				method: 'POST',
				url: 'customer-management/bills/billing-request',
			}),
			downloadBillingRequest: ({ period }: { period: string }) => ({
				method: 'GET',
				url: `customer-management/bills/billing-request/download?period=${period}`,
			}),
			getPaymentTokens: {
				method: 'GET',
				url: 'payment-processing-service/v1/payment-tokens',
			},
		},
		getDataUsage: (accountNumber: string) => ({
			method: 'GET',
			url: `customer-management/customer/usage?accountNumber=${accountNumber}`,
		}),
		getEbillInfo: {
			method: 'POST',
			url: `customer-account/customer-attributes`,
		},
	},
	omantelMicroApi: {
		microbundleService: {
			url: 'product-orchestration/products/microbundle/service',
			method: 'POST',
		},
		microbundleServiceInfo: {
			url: 'product-orchestration/products/microbundle/service-status',
			method: 'POST',
		},
		isRiyadaCustomer: isRiyadaCustomerGenerator,
		fbbProBandwidthOnDemand: {
			url: 'product-service/product/addon/offer',
			method: 'POST',
		},
		fbbProBandwidthOnDemandSubmitRequest: {
			url: 'order-service/bandwidth-on-demand',
			method: 'POST',
		},
		createFbbOrder: createFbbOrder,
		changeFbbOrder: {
			url: 'order-service/change-plan',
			method: 'POST',
		},
		getFbbOrderSummary: {
			url: 'order-service/fbb-order-summary',
			method: 'POST',
		},
		getNotifications: (limit: number) => {
			return {
				url: `notification-service/notification?type=NOTIFICATION&limit=${limit}`,
			};
		},
		readAllNotifications: {
			url: 'notification-service/notification/read-all',
			method: 'POST',
		},
		readNotification: readNotification,
		getBoosterOffer: getBtlPlans,
		validateUserName: validateUserName,
		subscriberProducts: getSubscriberProductsGenerators,
	},
	securityServices: {
		getNmfloId: {
			url: 'security-service/token/qualtrics?isCorporateUser=true',
			method: 'GET',
		},
		loginWithOTP: {
			url: 'security-service/auth/login',
			method: 'POST',
		},
		validateLoginOTP: {
			url: 'security-service/auth/validateAndLogin',
			method: 'POST',
		},
		getPasswordEncryptionKey: {
			url: 'security-service/auth/getKey',
			method: 'POST',
		},
	},
	eshopApi: {
		products: {
			getProductsByParentCategory: getProductsByParentCategoryGenerator,
			getInventoryByProductId: getInventoryByProductIdGenerator,
			getProductById: getProductByIdGenerator,
			getCatEntry: getCatEntryGenerator,
			getIdentity: addIdentityGenerator,
			cart: cartGenerator,
			getPurchaseDeviceHistory: getPurchaseDeviceHistoryGenerator,
			getPurchaseDeviceOrder: getPurchaseDeviceOrderGenerator,
			getOrderTracking: getOrderTrackingGenerator,
		},
	},
};

export default endpoints;
